import {Presenter} from '../../../Support/with_presenter';
import {Snippet} from '../../../Models/Snippet';
import {SnippetService} from '../../../Network/SnippetService';

export class PostProcessingPresenter implements Presenter {
    public _triggeredPostProcessing = false;

    public get isPostProcessing() {
        if (this._triggeredPostProcessing) {
            return true;
        }
        return this.snippets.some((snippet) => snippet.startedProcessingAt !== null);
    }

    public get shouldPostProcess() {
        return this.snippetRequiringPostProcessing.length > 0;
    }

    private get snippetRequiringPostProcessing(): Snippet[] {
        return this.snippets.filter((snippet) => {
            return (
                snippet.rSquaredTotalStroke === null ||
                snippet.rSquaredPrePeak === null ||
                snippet.rSquaredPostPeak === null
            );
        });
    }

    constructor(private snippets: Snippet[], private snippetService: SnippetService) {}

    public mount(): void {
        /* Noop */
    }

    public unmount(): void {
        /* Noop */
    }

    public async onClickStartProcessing() {
        this._triggeredPostProcessing = true;
        await this.snippetService.startPostProcessing(this.snippetRequiringPostProcessing.map((snippet) => snippet.id));
    }
}
